import React, { useCallback } from "react"

export interface UseMenuPayload {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void
  onContextMenu: (event: React.MouseEvent<HTMLButtonElement>) => void
  anchorEl: HTMLElement | null
  onClose: () => void
  open: boolean
}

export const useMenu = (): UseMenuPayload => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const onClick = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }, [])

  const onContextMenu = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      // Prevents the browser right click menu from also showing
      event.preventDefault()
      setAnchorEl(event.currentTarget)
    },
    [],
  )

  const onClose = useCallback(() => {
    setAnchorEl(null)
  }, [])

  return {
    anchorEl,
    open,
    onClick,
    onContextMenu,
    onClose,
  }
}
